import { apiRequest } from 'utils/request'
import { signals } from 'constants/routes'

export const get = async () => {
  const { data } = await apiRequest({
    uri: signals,
  })

  return data
}
